import { FLOATING_TOOLTIP_DISMISS_PARAMS } from '../../../hooks'

export const TOOLTIP_DISMISS_PARAMS = {
  ...FLOATING_TOOLTIP_DISMISS_PARAMS,
  enabled: true,
}
